<template>
  <div class="wrapper">
    <chat-header></chat-header>
    <chat-contents
      :form-count="formCount"
      @form-countup="formCountup"
    ></chat-contents>
    <chat-footer
      :total="formCount.total"
      :answer="formCount.answer"
    ></chat-footer>
  </div>
</template>

<script>
import ChatHeader from './ChatHeader'
import ChatContents from './ChatContents'
import ChatFooter from './ChatFooter'

export default {
  name: 'ChatWrap',
  components: {
    ChatHeader,
    ChatContents,
    ChatFooter
  },
  data: function () {
    return {
      formCount: {
        total: 10,
        answer: 0
      }
    }
  },
  beforeCreate: function () {},
  created: function () {},
  mounted: function () {},
  beforeUpdate: function () {},
  updated: function () {},
  methods: {
    formCountup: function () {
      this.formCount.answer += 1
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChatWrap.vue